import React from 'react';
import Stats from 'components/stats';
import CourseStats from 'analytics/courseStats';
import LearnerStats from 'analytics/learnerStats';
import LearnerLoginGraph from 'analytics/loginStats';
import LearnerEnrollmentGraph from 'analytics/enrollmentStats';
import TopCohortsGraph from 'analytics/topCohortsStats';
import MAUReports from 'analytics/mauReports';
import {
  Styled,
  AnalyticsStats,
} from './styled';

const Analytics = () => (
  <Styled>
    <AnalyticsStats>
      <Stats />
      <LearnerLoginGraph />
      <LearnerEnrollmentGraph />
      <TopCohortsGraph />
    </AnalyticsStats>
    <CourseStats />
    <LearnerStats />
    <MAUReports />
  </Styled>
);

export default Analytics;
